// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.statsHeader_QLsRe {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 16px;
  margin-bottom: 14px;
  padding: 10px 10px 0px;
  align-items: flex-start;
}

.statCard_e7D0u {
  background: var(--white-background);
  padding: 8px 14px 0px;
  border-radius: 12px;
  height: -webkit-fill-available;
  height: -moz-available;
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 4px;

  .title_Wzhcy{
    color:var(--black-color)
  }

  &.default_LpIWj {
    border: 1px solid var(--e2e8f0-border);
  }

  &.green_InrBG {
    background: var(--059669-background);
  }
}

.statCard_e7D0u.container_kxN9z {
  border: 1px solid var(--d9-background);
  border-radius: 12px;
}

.statCard_e7D0u h3 {
  font-size: 13px;
  color: var(--64748b-color);

  margin: 0px;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 0.025em;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.statCard_e7D0u.green_InrBG .statValue_BpdCq {
  color: var(--059669-color);
}

.statCard_e7D0u.green-bg_hjc5U {
  background: linear-gradient(135deg, var(--10b981-background) 0%, var(--059669-background) 100%);
  color: var(--white-color);
}

.statCard_e7D0u.green-bg_hjc5U h3,
.statCard_e7D0u.green-bg_hjc5U .statSubtitle_w4te_ {
  color: var(--white-stastHeader-color);
}

.statValue_BpdCq {
  font-size: 30px;
  font-weight: bold;
  padding-bottom: 4px;
  color: var(--1e293b-color);
  display: inline-flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
}

.statValue_BpdCq.border_VEHxe {
  border-bottom: 3px solid var(--d9-background);
}

.statSubtitle_w4te_ {
  font-size: 12px;
  color: var(--94a3b8-color);
  text-align: right;
  display: flex;
  align-items: center;
  gap: 4px;
  justify-content: flex-end;
 

  .statSubtitleValue_IdpZC {
    font-weight: 600;
    color: var(--059669-background);
  }
   .grey_AlK47{
    color:var(--94a3b8-color);
  }
  .statSubtitleText_qejYz{
    font-weight: 500;
  }
}

@media (max-width: 1024px) {
  .statsHeader_QLsRe {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 768px) {
  .statsHeader_QLsRe {
    grid-template-columns: repeat(2, 1fr);
  }
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/DashboardComponents/Main/StatsHeader/StatsHeader.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;EACrB,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,QAAQ;;EAER;IACE;EACF;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,oCAAoC;EACtC;AACF;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,0BAA0B;;EAE1B,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,uBAAuB;;EAEvB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,+FAA+F;EAC/F,yBAAyB;AAC3B;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;EAC1B,oBAAoB;EACpB,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;;;EAGzB;IACE,gBAAgB;IAChB,+BAA+B;EACjC;GACC;IACC,yBAAyB;EAC3B;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF","sourcesContent":[".statsHeader {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 16px;\n  margin-bottom: 14px;\n  padding: 10px 10px 0px;\n  align-items: flex-start;\n}\n\n.statCard {\n  background: var(--white-background);\n  padding: 8px 14px 0px;\n  border-radius: 12px;\n  height: -webkit-fill-available;\n  height: -moz-available;\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  gap: 4px;\n\n  .title{\n    color:var(--black-color)\n  }\n\n  &.default {\n    border: 1px solid var(--e2e8f0-border);\n  }\n\n  &.green {\n    background: var(--059669-background);\n  }\n}\n\n.statCard.container {\n  border: 1px solid var(--d9-background);\n  border-radius: 12px;\n}\n\n.statCard h3 {\n  font-size: 13px;\n  color: var(--64748b-color);\n\n  margin: 0px;\n  font-weight: bold;\n  text-transform: uppercase;\n  letter-spacing: 0.025em;\n\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.statCard.green .statValue {\n  color: var(--059669-color);\n}\n\n.statCard.green-bg {\n  background: linear-gradient(135deg, var(--10b981-background) 0%, var(--059669-background) 100%);\n  color: var(--white-color);\n}\n\n.statCard.green-bg h3,\n.statCard.green-bg .statSubtitle {\n  color: var(--white-stastHeader-color);\n}\n\n.statValue {\n  font-size: 30px;\n  font-weight: bold;\n  padding-bottom: 4px;\n  color: var(--1e293b-color);\n  display: inline-flex;\n  width: 100%;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.statValue.border {\n  border-bottom: 3px solid var(--d9-background);\n}\n\n.statSubtitle {\n  font-size: 12px;\n  color: var(--94a3b8-color);\n  text-align: right;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  justify-content: flex-end;\n \n\n  .statSubtitleValue {\n    font-weight: 600;\n    color: var(--059669-background);\n  }\n   .grey{\n    color:var(--94a3b8-color);\n  }\n  .statSubtitleText{\n    font-weight: 500;\n  }\n}\n\n@media (max-width: 1024px) {\n  .statsHeader {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n@media (max-width: 768px) {\n  .statsHeader {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"statsHeader": `statsHeader_QLsRe`,
	"statCard": `statCard_e7D0u`,
	"title": `title_Wzhcy`,
	"default": `default_LpIWj`,
	"green": `green_InrBG`,
	"container": `container_kxN9z`,
	"statValue": `statValue_BpdCq`,
	"green-bg": `green-bg_hjc5U`,
	"statSubtitle": `statSubtitle_w4te_`,
	"border": `border_VEHxe`,
	"statSubtitleValue": `statSubtitleValue_IdpZC`,
	"grey": `grey_AlK47`,
	"statSubtitleText": `statSubtitleText_qejYz`
};
export default ___CSS_LOADER_EXPORT___;
